module.exports = __webpack_public_path__ + "img/01.9b4f06d3.png";